import { render, staticRenderFns } from "./thrideTerminalForm.vue?vue&type=template&id=bf9d8862"
import script from "./thrideTerminalForm.vue?vue&type=script&lang=js"
export * from "./thrideTerminalForm.vue?vue&type=script&lang=js"
import style0 from "./thrideTerminalForm.vue?vue&type=style&index=0&id=bf9d8862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports